import React from "react";
import { Link, NavLink } from "react-router-dom";
const serviceURL = "http://serviceecom.devsaycheese.com/";
const MobileSidebar = (props) => {
  const logout = () => {
    document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/;domain=.devsaycheese.com;"); });
    window.localStorage.clear();
    props.toggle();
    props.logout();
  };
  return (
    <React.Fragment>
      <div
        className={`sidebar ${props.menu}`}
        style={{ overflow: "scroll", display: "none" }}
      >
        <button className="close" onClick={props.toggle}>
          <i className="fas fa-times"></i>
        </button>
        <Link
          to={`${process.env.PUBLIC_URL}/`}
          className="navbar-brand "
          id="logo"
          onClick={props.toggle}
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/Logo NEW.png`}
            alt="App landing"
            style={{ maxWidth: "150px" }}
          />
        </Link>
        <ul className="navbar-nav">
          <NavLink
            to={`${process.env.PUBLIC_URL}/`}
            className="nav-item"
            exact
            onClick={props.toggle}
          >
            <span className="nav-link">
              <i className="fas fa-home mr-3"></i> Home
            </span>
          </NavLink>
          <a
            href={
              props.isSeeker === true
                ? `${serviceURL}?t=${localStorage.getItem("utoken")}`
                : serviceURL
            }
            className="nav-item "
            exact
            onClick={props.toggle}
          >
            <span className="nav-link">
              <i className="fas fa-hands-helping mr-3"></i> Services
            </span>
          </a>
          {props.token && <NavLink
            to={props.isSeeker ? `/myplace/seeker/personalise` : `/myplace/giver/profile-g`}
            className="nav-item"
            exact
          >
            <span className="nav-link">
              <i className="fas fa-globe mr-3"></i> My Place
            </span>
          </NavLink>
          }
          <a
            href={`/networking`}
            className="nav-item "
            exact
            onClick={props.toggle}
          >
            <span className="nav-link">
              <i className="fas fa-globe mr-3"></i> Network
            </span>
          </a>

          <NavLink
            to={`${process.env.PUBLIC_URL}/myplace/seeker/self-learning`}
            className="nav-item "
            exact
            onClick={props.toggle}
          >
            <span className="nav-link">
              <i className="fas fa-graduation-cap mr-3"></i>Self Learning
            </span>
          </NavLink>
          <a
            href={`/whats-new`}
            className="nav-item"
            exact
            onClick={props.toggle}
          >
            <span className="nav-link">
              <i className="fas fa-bolt mr-3"></i> Whats New
            </span>
          </a>
          <NavLink
            to={`${process.env.PUBLIC_URL}/aboutus`}
            className="nav-item "
            exact
            onClick={props.toggle}
          >
            <span className="nav-link">
              <i className="fas fa-question-circle mr-3"></i> About Us
            </span>
          </NavLink>
          <NavLink
            to={`${process.env.PUBLIC_URL}/corporate`}
            className="nav-item "
            exact
            onClick={props.toggle}
          >
            <span className="nav-link">
              <i className="fas fa-globe mr-3"></i> Corporate
            </span>
          </NavLink>
          {!props.token ? (
            <NavLink
              to={`${process.env.PUBLIC_URL}/login`}
              className="nav-item "
              exact
              onClick={props.toggle}
            >
              <span className="nav-link">
                <i className="fas fa-user mr-3"></i> Login
              </span>
            </NavLink>
          ) : (
            <NavLink
              to={`${process.env.PUBLIC_URL}`}
              className="nav-item "
              exact
              onClick={logout}
            >
              <span className="nav-link">
                <i className="fas fa-user mr-3"></i> Logout
              </span>
            </NavLink>
          )}
        </ul>
      </div>
    </React.Fragment>
  );
};

export default MobileSidebar;
